import { cva } from 'class-variance-authority';
import styles from '../presentation/styles.module.scss';

export const alertVariants = cva(styles.wrapper, {
  variants: {
    status: {
      info: styles.info,
      success: styles.success,
      error: styles.error,
      warning: styles.warning,
    },
  },
  defaultVariants: {
    status: 'info',
  },
});

export const iconVariants = cva(styles.icon, {
  variants: {
    status: {
      info: styles.iconInfo,
      success: styles.iconSuccess,
      error: styles.iconError,
      warning: styles.iconWarning,
    },
  },
  defaultVariants: {
    status: 'info',
  },
});

export const closeButtonVariants = cva(styles.closeButton, {
  variants: {
    status: {
      info: styles.closeButtonInfo,
      success: styles.closeButtonSuccess,
      error: styles.closeButtonError,
      warning: styles.closeButtonWarning,
    },
  },
  defaultVariants: {
    status: 'info',
  },
});
